export const GridTemplate = ({areas, columns, rows}) => `
     grid-template-areas: ${areas || 'initial'};
     grid-template-columns: ${columns || 'initial'};
     grid-template-rows: ${rows || 'initial'};
`;
